/**
 * Customer type values
 */
export enum CustomerTypeEnum {
	COMPANY = 'company',
	INDIVIDUAL = 'individual',
}
